import { baseApi } from './baseApi'

export const notificationsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: ({ offset = 0, limit = 20, unreadOnly = false } = {}) => ({
                url: '/notifications',
                params: { offset, limit, ...(unreadOnly ? { unreadOnly: 'true' } : {}) }
            }),
            providesTags: (result) =>
                result?.items
                    ? [
                        ...result.items.map((n) => ({ type: 'Notifications', id: n.tid })),
                        { type: 'Notifications', id: 'LIST' }
                    ]
                    : [{ type: 'Notifications', id: 'LIST' }]
        }),

        getUnreadNotificationsCount: builder.query({
            query: () => '/notifications/unread-count',
            providesTags: [{ type: 'Notifications', id: 'COUNT' }]
        }),

        markNotificationRead: builder.mutation({
            query: (notificationId) => ({
                url: `/notifications/${notificationId}/read`,
                method: 'POST'
            }),
            invalidatesTags: [
                { type: 'Notifications', id: 'LIST' },
                { type: 'Notifications', id: 'COUNT' }
            ]
        }),

        markAllNotificationsRead: builder.mutation({
            query: () => ({ url: '/notifications/read-all', method: 'POST' }),
            invalidatesTags: [
                { type: 'Notifications', id: 'LIST' },
                { type: 'Notifications', id: 'COUNT' }
            ]
        }),

        deleteNotification: builder.mutation({
            query: (notificationId) => ({
                url: `/notifications/${notificationId}`,
                method: 'DELETE'
            }),
            invalidatesTags: [
                { type: 'Notifications', id: 'LIST' },
                { type: 'Notifications', id: 'COUNT' }
            ]
        }),

        getNotificationPreferences: builder.query({
            query: () => '/notifications/preferences',
            providesTags: [{ type: 'Notifications', id: 'PREFERENCES' }]
        }),

        updateNotificationPreferences: builder.mutation({
            query: (items) => ({
                url: '/notifications/preferences',
                method: 'PUT',
                body: { items }
            }),
            invalidatesTags: [{ type: 'Notifications', id: 'PREFERENCES' }]
        }),

        sendTestNotification: builder.mutation({
            query: () => ({ url: '/notifications/test', method: 'POST' }),
            invalidatesTags: [
                { type: 'Notifications', id: 'LIST' },
                { type: 'Notifications', id: 'COUNT' }
            ]
        })
    })
})

export const {
    useGetNotificationsQuery,
    useGetUnreadNotificationsCountQuery,
    useMarkNotificationReadMutation,
    useMarkAllNotificationsReadMutation,
    useDeleteNotificationMutation,
    useGetNotificationPreferencesQuery,
    useUpdateNotificationPreferencesMutation,
    useSendTestNotificationMutation
} = notificationsApi
